module.exports = __webpack_public_path__ + "img/260.3e8b981a.jpg";